/*
 * Vencord, a modification for Discord's desktop app
 * Copyright (c) 2022 Vendicated and contributors
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

(window.VencordStyles ??= new Map()).set("src/plugins/callTimer/alignedChatInputFix.css", {
    name: "src/plugins/callTimer/alignedChatInputFix.css",
    source: "[class*=\"panels\"] [class*=\"inner\"],\n[class*=\"rtcConnectionStatus\"] {\n    height: fit-content !important;\n}",
    classNames: {},
    dom: null,
});

export default "src/plugins/callTimer/alignedChatInputFix.css";
